import { Component } from '@angular/core';
import { UserProfileService } from '../service/user-profile.service';
import { YearPerformanceService } from '../service/year-performance.service';
import { YearPerformance } from '../model/year-performance';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { PerformanceYearSection } from '../model/performance-year-section';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { VjsPlayerComponent } from '../vjs-player/vjs-player.component';
import {ThemePalette} from '@angular/material/core';

import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-year-performance',
  standalone: true,
  imports: [
    // VjsPlayerComponent,
    CommonModule,
    MatListModule,
    MatExpansionModule,
    MatIconModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    TranslateModule,
    RouterLink,
  ],
  templateUrl: './year-performance.component.html',
  styleUrl: './year-performance.component.css'
})
export class YearPerformanceComponent {
  color : ThemePalette = 'accent';
  isLoading = false;
  panelOpenState = false;
  apexId!:string;
  date = new Date();
  // yearPerformanceObjectArray!:YearPerformance[];
  yearPerformanceObjectArray!:any[];
  constructor(
    private userProfileService: UserProfileService,
    private yearPerformanceService: YearPerformanceService,
    translate: TranslateService,
  ) { 
    translate.setDefaultLang('en');

    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    translate.use(browserLangToUse);

    translate.get('ml_143931').subscribe((res: string) => {
      this.yes = res;
      // console.log(this.yes);
    });
    translate.get('ml_143932').subscribe((res: string) => {
      this.no = res;
    });
  }
  yes = '';
  no = '';

  KpiDrivingBehaviorArray!:YearPerformance[];
  KpiITToolUsageArray!:YearPerformance[];
  KpiEconomyArray!:YearPerformance[];
  KpiOthersArray!:YearPerformance[];

  PerformanceYearSectionKpiDrivingBehavior: PerformanceYearSection<YearPerformance> | undefined;
  PerformanceYearSectionKpiITToolUsage:PerformanceYearSection<YearPerformance> | undefined;
  PerformanceYearSectionKpiEconomy:PerformanceYearSection<YearPerformance> | undefined;
  PerformanceYearSectionKpiOthers:PerformanceYearSection<YearPerformance> | undefined;
  PerformanceYearSectionKpiSafety:PerformanceYearSection<YearPerformance> | undefined;

  categoryNameSortIdMap!:Map<string, YearPerformance>;

  PerformanceYearSectionArray: Array<PerformanceYearSection<any>> = [];

  ngOnInit(): void {
    
    
    this.isLoading = true;
    let apexId = localStorage.getItem("apexid");
    if(apexId !== null){
      this.apexId = apexId;
      
      this.categoryNameSortIdMap = new Map();
      

      this.yearPerformanceService.getYearPerformanceByApexIdAndYear(this.apexId,this.date.toISOString()!.split('T')[0].substring(0, 7)).subscribe(responseYearPerformanceObjectArray => {
        
        this.yearPerformanceObjectArray = responseYearPerformanceObjectArray;
        this.yearPerformanceObjectArray = this.yearPerformanceObjectArray.sort((a, b) => a.sort_Id - b.sort_Id);
        


        // for (const yearPerformanceObject of this.yearPerformanceObjectArray){
        //   let categoryCharacter = yearPerformanceObject.kpiId.substring(0, 1);
        //   if(this.categoryNameSortIdMap.has(categoryCharacter)){
            
        //   }
        //   else{
        //     this.categoryNameSortIdMap.set(categoryCharacter, yearPerformanceObject);
        //   }
        // }
        
        // for (const key of this.categoryNameSortIdMap.keys()){
        //   if(key === 'B'){
        //     let yearPerformanceKpiDrivingBehaviorObject = this.categoryNameSortIdMap.get(key);
        //     let newPerformanceYearSectionKpiDrivingBehavior: PerformanceYearSection<YearPerformance> = { 
        //       name: yearPerformanceKpiDrivingBehaviorObject!.kpiCategoryName,
        //       translation_Id : yearPerformanceKpiDrivingBehaviorObject!.kpiCategory_Translation_Id,
        //       sort_Id : yearPerformanceKpiDrivingBehaviorObject!.sort_Id,
        //       kpiCategoryType : 'B',
        //       kpiPerformances: [] 
        //     };
        //     this.PerformanceYearSectionKpiDrivingBehavior = newPerformanceYearSectionKpiDrivingBehavior;
        //   }
        //   if(key === 'I'){
        //     let yearPerformanceKpiITToolUsageObject = this.categoryNameSortIdMap.get(key);
        //     let newPerformanceYearSectionKpiITToolUsage: PerformanceYearSection<YearPerformance> = { 
        //       name: yearPerformanceKpiITToolUsageObject!.kpiCategoryName,
        //       translation_Id : yearPerformanceKpiITToolUsageObject!.kpiCategory_Translation_Id,
        //       sort_Id : yearPerformanceKpiITToolUsageObject!.sort_Id,
        //       kpiCategoryType : 'I',
        //       kpiPerformances: [] 
        //     };
        //     this.PerformanceYearSectionKpiITToolUsage = newPerformanceYearSectionKpiITToolUsage;
        //   }
        //   if(key === 'E'){
        //     let yearPerformanceKpiEconomyObject = this.categoryNameSortIdMap.get(key);
        //     let newPerformanceYearSectionKpiEconomy: PerformanceYearSection<YearPerformance> = { 
        //       name: yearPerformanceKpiEconomyObject!.kpiCategoryName,
        //       translation_Id : yearPerformanceKpiEconomyObject!.kpiCategory_Translation_Id,
        //       sort_Id : yearPerformanceKpiEconomyObject!.sort_Id,
        //       kpiCategoryType : 'E',
        //       kpiPerformances: [] 
        //     };
        //     this.PerformanceYearSectionKpiEconomy = newPerformanceYearSectionKpiEconomy;
        //   }
        //   if(key === 'T'){
        //     let yearPerformanceKpiOthersObject = this.categoryNameSortIdMap.get(key);
        //     let newPerformanceYearSectionKpiOthers: PerformanceYearSection<YearPerformance> = { 
        //       name: yearPerformanceKpiOthersObject!.kpiCategoryName,
        //       translation_Id : yearPerformanceKpiOthersObject!.kpiCategory_Translation_Id,
        //       sort_Id : yearPerformanceKpiOthersObject!.sort_Id,
        //       kpiCategoryType : 'T',
        //       kpiPerformances: [] 
        //     };
        //     this.PerformanceYearSectionKpiOthers = newPerformanceYearSectionKpiOthers;
        //   }
        //   if(key === 'S'){
        //     let yearPerformanceKpiOthersObject = this.categoryNameSortIdMap.get(key);
        //     let newPerformanceYearSectionKpiSafety: PerformanceYearSection<YearPerformance> = { 
        //       name: yearPerformanceKpiOthersObject!.kpiCategoryName,
        //       translation_Id : yearPerformanceKpiOthersObject!.kpiCategory_Translation_Id,
        //       sort_Id : yearPerformanceKpiOthersObject!.sort_Id,
        //       kpiCategoryType : 'S',
        //       kpiPerformances: [] 
        //     };
        //     this.PerformanceYearSectionKpiSafety = newPerformanceYearSectionKpiSafety;
        //   }           
        // }
  
        // for (const yearPerformanceObject of this.yearPerformanceObjectArray){
        //   let categoryCharacter = yearPerformanceObject.kpiId.substring(0, 1);
        //   switch (categoryCharacter) {
        //     case 'T':
        //       // this.KpiOthersArray.push(yearPerformanceObject);
        //       this.PerformanceYearSectionKpiOthers?.kpiPerformances.push(yearPerformanceObject);
        //       break;
        //     case 'E':
        //       // this.KpiEconomyArray.push(yearPerformanceObject);
        //       this.PerformanceYearSectionKpiEconomy?.kpiPerformances.push(yearPerformanceObject);
        //       break;
        //     case 'I':
        //       // this.KpiITToolUsageArray.push(yearPerformanceObject);
        //       this.PerformanceYearSectionKpiITToolUsage?.kpiPerformances.push(yearPerformanceObject);
        //       break;
        //     case 'B':
        //       // this.KpiDrivingBehaviorArray.push(yearPerformanceObject);
        //       this.PerformanceYearSectionKpiDrivingBehavior?.kpiPerformances.push(yearPerformanceObject);
        //       break;
        //     case 'S':
        //       // this.KpiDrivingBehaviorArray.push(yearPerformanceObject);
        //       this.PerformanceYearSectionKpiSafety?.kpiPerformances.push(yearPerformanceObject);
        //       break;
        //   }
        // }
        
        // if(this.PerformanceYearSectionKpiDrivingBehavior !== undefined){
        //   this.PerformanceYearSectionArray.push(this.PerformanceYearSectionKpiDrivingBehavior);
        // }
        // if(this.PerformanceYearSectionKpiITToolUsage !== undefined){
        //   this.PerformanceYearSectionArray.push(this.PerformanceYearSectionKpiITToolUsage);
        // }
        // if(this.PerformanceYearSectionKpiEconomy !== undefined){
        //   this.PerformanceYearSectionArray.push(this.PerformanceYearSectionKpiEconomy);
        // }
        // if(this.PerformanceYearSectionKpiOthers !== undefined){
        //   this.PerformanceYearSectionArray.push(this.PerformanceYearSectionKpiOthers);
        // }
        // if(this.PerformanceYearSectionKpiSafety !== undefined){
        //   this.PerformanceYearSectionArray.push(this.PerformanceYearSectionKpiSafety);
        // }
  
        // this.PerformanceYearSectionArray = this.PerformanceYearSectionArray.sort((a, b) => a.sort_Id - b.sort_Id);
  

        this.isLoading=false;
      });
    }
    // this.userProfileService.getUserProfileMe().subscribe(me => {
    //   this.apexId = me[0].apexId;
    //   // this.apexId = 'DAIK1';
      

    // });
    
  }
}
